export const APP_NAME = 'HomeHero';
export const APP_TAGLINE = 'Service Marketplace Admin';

export const MOCK_ADMIN = {
  email: 'admin@homehero.com',
  password: 'admin123',
  name: 'Alex Morgan',
  id: 'ADM-001',
};

export const ROUTES = {
  login: '/login',
  forgotPassword: '/forgot-password',
  verifyOtp: '/verify-otp',
  resetPassword: '/reset-password',
  dashboard: '/dashboard',
  users: '/users',
  userDetail: '/users/:id',
  providers: '/providers',
  providerDetail: '/providers/:id',
  categories: '/categories',
  categoryDetail: '/categories/:id',
  requests: '/requests',
  requestDetail: '/requests/:id',
  jobs: '/jobs',
  jobDetail: '/jobs/:id',
  payments: '/payments',
  paymentDetail: '/payments/:id',
  complaints: '/complaints',
  complaintDetail: '/complaints/:id',
  reviews: '/reviews',
  reviewDetail: '/reviews/:id',
  notifications: '/notifications',
  notificationDetail: '/notifications/:id',
  reports: '/reports',
  cms: '/cms',
  cmsPageEdit: '/cms/pages/:id',
  settings: '/settings',
} as const;

export const PAGE_SIZE = 10;

export const SERVICE_CATEGORIES = [
  'Plumbing',
  'Electrical',
  'Cleaning',
  'Painting',
  'Repairs',
  'AC Maintenance',
  'Carpentry',
  'Moving',
  'Landscaping',
  'Appliance Repair',
] as const;

export const DATE_RANGE_PRESETS = [
  { label: 'Today', value: 'today' },
  { label: 'Yesterday', value: 'yesterday' },
  { label: 'Last 7 Days', value: 'last7' },
  { label: 'Last 30 Days', value: 'last30' },
  { label: 'This Month', value: 'thisMonth' },
  { label: 'Last Month', value: 'lastMonth' },
  { label: 'Custom', value: 'custom' },
] as const;
